var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67188 11.8821C7.67188 13.0206 8.66188 13.9384 9.89186 13.9384H12.4019C13.4719 13.9384 14.3419 13.1353 14.3419 12.1469C14.3419 11.0702 13.8119 10.6907 13.0219 10.4435L8.99187 9.20798C8.20187 8.96086 7.67188 8.58137 7.67188 7.50465C7.67188 6.51619 8.54188 5.71307 9.61186 5.71307H12.1219C13.3519 5.71307 14.3419 6.63092 14.3419 7.76941",
    stroke: "#292D32",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.53021V15.1208",
    stroke: "#292D32",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.17784C1 2.7651 3 1 8 1H14C19 1 21 2.7651 21 7.17784V12.4731C21 16.8859 19 18.651 14 18.651H8C3 18.651 1 16.8859 1 12.4731V10.7345",
    stroke: "#292D32",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.62b734f49fdac8cf5bfe531dc0657e8e.svg";
export { ForwardRef as ReactComponent };